import { G35_CURRICULUM } from "./3-5";
import { G68_CURRICULUM } from "./6-8";
import { K2_CURRICULUM } from "./k-2";
export type { MindUPLesson } from "./k-2";

export const GRADE_BANDS = ["K-2", "3-5", "6-8"] as const;
export type GradeBand = (typeof GRADE_BANDS)[number];

const ALL_CURRICULUM = [...K2_CURRICULUM, ...G35_CURRICULUM, ...G68_CURRICULUM];

export function getAllLessons() {
  return ALL_CURRICULUM;
}

export function getLessonsByGradeLevel(gradeLevel: GradeBand) {
  return ALL_CURRICULUM.filter((lesson) => lesson.gradeLevel === gradeLevel);
}

export function getLessonById(id: string) {
  return ALL_CURRICULUM.find((lesson) => lesson.id === id);
}
